import { useInfiniteQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { ProductParams, ProductsResponse } from './useProducts';

export function useInfiniteProducts(params: Omit<ProductParams, 'page'>) {
    const queryFn = async ({ pageParam }: { pageParam: number }) => {
        const response = await api.get<ProductsResponse>('/product', {
            params: {
                ...params,
                page: pageParam,
            },
        });

        return response.data;
    };

    return useInfiniteQuery({
        queryKey: [params],
        queryFn: ({ pageParam = 1 }) => queryFn({ pageParam }),
        getNextPageParam: (lastPage) => {
            const { next_page_url, current_page } = lastPage.meta;
            return next_page_url ? current_page + 1 : undefined;
        },
        refetchOnWindowFocus: false,
    });
}
